import React from "react";

const STATUS_CLS = {
    Aligned: "bg-green-50 text-green-700 border-green-200",
    Contradiction: "bg-red-50 text-red-700 border-red-200",
    Unknown: "bg-gray-100 text-gray-600 border-gray-200",
    "Approved exception": "bg-amber-50 text-amber-700 border-amber-200",
};
const fmt = (d) => (d ? new Date(d).toLocaleString() : "—");

// Policy assurance (prototype "Policy assurance"): every requirement check of every policy's
// version in force against live Security Insights controls.
const PolicyAssuranceTab = ({ results, onOpenPolicy, onRefresh }) => {
    if (!results) return <p className="text-xs text-gray-400">Loading assurance…</p>;
    const unknown = results.filter(r => r.status === "Unknown").length;
    const covered = results.filter(r => r.status === "Approved exception").length;

    return (
        <div className="space-y-3">
            <div className="text-xs text-gray-600 bg-white border border-gray-200 rounded-lg px-3 py-2">
                <b>Technical evidence against policy requirements.</b> Checks apply to each policy's version in force and read the live controls synced from your connected sources (Entra, Defender, Sentinel, Okta and others). Evidence older than the configured staleness window (default 24 hours) is Unknown. Active exceptions keep mismatches visible. Rule outcomes are evidence-based checks, not a conclusion about overall compliance.
            </div>
            <div className="flex items-center gap-3 text-xs text-gray-500">
                {onRefresh && <button onClick={onRefresh} className="px-3 py-1.5 bg-indigo-600 text-white rounded-lg font-medium">Refresh</button>}
                <span>{results.length} checks · {unknown} unknown · {covered} covered by exceptions</span>
            </div>
            {results.length === 0 && <p className="text-xs text-gray-400">No requirement checks yet. Open a policy's Technical assurance tab (on an unpublished draft) to add requirements, then publish.</p>}
            {results.length > 0 && (
                <div className="bg-white border border-gray-200 rounded-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-xs">
                            <thead><tr className="text-left text-gray-400 uppercase tracking-wide border-b border-gray-200">
                                <th className="px-3 py-2">Policy / requirement</th><th className="px-3 py-2">Object / source</th><th className="px-3 py-2">Expected / observed</th><th className="px-3 py-2">Assessment</th><th className="px-3 py-2"></th>
                            </tr></thead>
                            <tbody>
                                {results.map(r => (
                                    <tr key={`${r.policyId}-${r.requirementId}`} className="border-b border-gray-100 align-top">
                                        <td className="px-3 py-2">
                                            <div className="text-indigo-700 font-medium">{r.policyTitle} <span className="text-gray-400">v{r.version}</span></div>
                                            <div className="text-gray-700">{r.requirement}</div>
                                        </td>
                                        <td className="px-3 py-2 text-gray-600">
                                            <div>{r.object}</div>
                                            <div className="text-gray-400">{r.controlTitle || r.controlId} · {r.source || "No source"} · {fmt(r.observedAt)}</div>
                                        </td>
                                        <td className="px-3 py-2 text-gray-600">{r.expectedStatus} / {r.observedStatus || "No evidence"}</td>
                                        <td className="px-3 py-2">
                                            <span className={`px-1.5 py-0.5 rounded-full text-[10px] font-medium border ${STATUS_CLS[r.status] || STATUS_CLS.Unknown}`}>{r.status}</span>
                                            <div className="text-gray-400 mt-0.5"><b>Reason:</b> {r.reason}{r.exceptionTitle ? ` · exception "${r.exceptionTitle}"` : ""}</div>
                                        </td>
                                        <td className="px-3 py-2"><button onClick={() => onOpenPolicy?.(r.policyId, "assurance")} className="text-indigo-700 bg-indigo-50 border border-indigo-200 rounded px-2 py-0.5">Investigate</button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </div>
    );
};

export default PolicyAssuranceTab;
